//
import Service from '@/services/api/service'
import AccountModel from '@/models/Accounting/AccAccount'

//
import filters from './filters'

//
export default class extends Service {

    //
    static filters  = filters
    
    //
    static model = AccountModel
}
